// extracted by mini-css-extract-plugin
export default {"nav":"NavbarWide_nav__hYw8F","logo":"NavbarWide_logo__i4Opd","items":"NavbarWide_items__67BCh","borderActive":"NavbarWide_borderActive__es0RD"};